<template>
  <table class="table mb-0 arudd-processing-logs">
    <thead>
      <tr>
        <th class="text-center">Level</th>
        <th class="text-center">Logged At</th>
        <th class="text-center">Reference</th>
        <th>Details</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="log of logs"
        :key="log.Id"
        :class="log._tableClass"
      >
        <td class="fwfont font-weight-bold text-center position-relative no-pad">{{ log.Level }}</td>
        <td class="text-center" style="white-space: nowrap;">{{ log.LoggedAt | shortDateTime }}</td>
        <td class="text-center">{{ log.RecordIdentifier }}</td>
        <td>
          <div v-if="log.Message" class="text-left">
            <p class="font-weight-bold d-inline">Message:</p>
            <p style="overflow-wrap: anywhere; white-space: pre-line">
              {{ log.Message }}
            </p>
          </div>
          <div v-if="log.Guidance" class="text-left">
            <p class="font-weight-bold d-inline">Guidance:</p>
            <p style="overflow-wrap: anywhere; white-space: pre-line">
              {{ log.Guidance }}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import _filters from '@/mixins/filters.js';

export default {
	name: 'TableAruddProcessingLogs',

	mixins: [_filters],

	props: {
		logs: {
			type: Array,
			required: true,
		},
	},
};
</script>
